import {
  INIT_SUCCESS,
  INIT_FAIL,
  CHANGE_FILE_SELECTED,
  RESIZE_UPLOAD_SUCCESS,
  RESIZE_UPLOAD_FAIL,
  UPDATE_SUCCESS,
  UPDATE_FAIL,
  CHECK_AND_RELOAD_SUCCESS,
  CHECK_AND_RELOAD_FAIL
} from "../actions/updateSticker";

const initialState = {
  listId: null,
  itemId: null,
  stickerId: null,
  beforeStickerFile: null,
  selectedImageURL: null
};

const updateSticker = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        listId: payload.listId,
        itemId: payload.itemId,
        stickerId: payload.stickerId,
        beforeStickerFile: payload.beforeStickerFile
      };
    case INIT_FAIL:
      return {
        ...state
      };
    case CHANGE_FILE_SELECTED:
      return {
        ...state,
        selectedImageURL: payload.selectedImageURL
      };
    case RESIZE_UPLOAD_SUCCESS:
      return {
        ...state
      };
    case RESIZE_UPLOAD_FAIL:
      return {
        ...state,
        message: payload.message,
        error: payload.error
      };
    case UPDATE_SUCCESS:
      return {
        ...state
      };
    case UPDATE_FAIL:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message
      };
    case CHECK_AND_RELOAD_SUCCESS:
      return {
        ...state
      };
    case CHECK_AND_RELOAD_FAIL:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message
      };
    default:
      return {
        ...state
      };
  }
};

export default updateSticker;
